// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"waste-types_routeHeader_3eTbZ","addButton":"waste-types_addButton_1uAMR"};